import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dashboard from '../DashboardV4/Dashboard';
import { REACT_APP_APIURL } from '../../global/Environment';
import { getDemoDashboardCfg } from '../../services/siteDataService';

const getUserProfile = () => {
  return Promise.resolve({
    displayName: "Joe Horseplayer",
    firstName: "Joe",
    lastName: "Horseplayer",
    email: "demo@tripnotepros.com",
    id: "demo-user-id",
    language: "en"
  });
};

const NoteContent = () => {
  const noteBoxStyle = {
    display: 'inline-block',
    marginTop: '4px',
    padding: '10px 12px',
    backgroundColor: '#fff59d',
    color: '#202124',
    border: '1px solid #f0c14b',
    borderRadius: '8px',
    lineHeight: 1.5,
    fontWeight: 600
  };

  const linkStyle = {
    color: '#0b57d0',
    fontWeight: 700
  };

  const ctaStyle = {
    display: 'inline-block',
    marginTop: '10px',
    padding: '6px 12px',
    backgroundColor: '#39d377',
    color: '#082b1a',
    borderRadius: '999px',
    fontWeight: 800,
    textDecoration: 'none'
  };

  const url = 'https://dashboard.tripnotepros.com/signup';

  return (
    <span style={noteBoxStyle}>
      Go to <a href={url} style={linkStyle}>tripnotepros.com</a> to receive FREE highlight notes daily
      and purchase trip note analysis for today's entire card!
      <br />
      <a
        href={url}
        style={ctaStyle}
      >
        Sign Up
      </a>
    </span>
  );
};

// Replace notes for all races except the highlighted one
function replaceNotesForRaces(idxToLeaveAsIs, data) {
  if (!data?.data) {
    return;
  }
  let noteKey = 0;

  data.data.forEach((entry) => {
    if (!entry?.dates?.[0]?.races) {
      return;
    }

    entry.dates[0].races.forEach((race, idx) => {
      if (idx !== idxToLeaveAsIs && race?.horses) {
        race.horses.forEach((horse) => {
          if (horse?.notes) {
            horse.notes = horse.notes.map((note) => ({
              ...note,
              grade: 0,
              summary: '',
              reac_note: '',
              note: <NoteContent key={`demo-note-${++noteKey}`} />,
              isDemo: true // Flag to identify demo notes
            }));
          }
        });
      }
    });
  });
}

class DemoDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      raceNumber: null,
      raceData: null,
      isLoading: true,
      error: null
    };

    // Bind methods
    this.getRaceData = this.getRaceData.bind(this);
    this.getRaceIdxToHighlight = this.getRaceIdxToHighlight.bind(this);
  }

  async componentDidMount() {
    try {
      // Get demo configuration
      const cfg = await getDemoDashboardCfg();
      const raceNumber = cfg?.raceNumber || 1;

      this.setState({
        raceNumber,
        isLoading: false
      });
    } catch (error) {
      console.error('Error loading demo configuration:', error);
      this.setState({
        error: 'Failed to load demo configuration',
        isLoading: false,
        raceNumber: 1 // Fallback to race 1
      });
    }
  }

  getRaceData = async () => {
    const { raceNumber } = this.state;

    if (raceNumber === null) {
      return null;
    }

    const idxToLeaveAsIs = raceNumber - 1;

    try {
      const res = await fetch(`${REACT_APP_APIURL}/race/demo?lang=en`);

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const data = await res.json();

      if (!data?.data) {
        throw new Error('Invalid data structure received');
      }

      // Replace notes for all races except the featured one
      replaceNotesForRaces(idxToLeaveAsIs, data);

      // Store in state instead of module variable
      this.setState({ raceData: data.data });

      return data.data;
    } catch (error) {
      console.error('Error getting demo race data:', error);
      this.setState({ error: 'Failed to load demo race data' });

      // Instead of alert, return null and let Dashboard handle the error
      return null;
    }
  };

  getRaceIdxToHighlight = () => {
    const { raceData, raceNumber } = this.state;

    if (!raceData?.[0]?.dates?.[0]?.races || !raceNumber) {
      return 0;
    }

    const { races } = raceData[0].dates[0];
    const idx = races.findIndex(race => race.race_number === raceNumber);

    return idx !== -1 ? idx : 0;
  };

  render() {
    const { isLoading, error, raceNumber } = this.state;

    // Show loading state while getting race number
    if (isLoading) {
      return (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          Loading demo dashboard...
        </div>
      );
    }

    // Show error if configuration failed
    if (error && !raceNumber) {
      return (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <h2>Error Loading Demo</h2>
          <p>{error}</p>
          <button
            className="btn primary"
            onClick={() => window.location.reload()}
          >
            Retry
          </button>
        </div>
      );
    }

    return (
      <Dashboard
        history={this.props.history}
        getUserProfileOverRide={getUserProfile}
        getRaceDataOverRide={this.getRaceData}
        getRaceIdxToHighlight={this.getRaceIdxToHighlight}
      />
    );
  }
}

// Map Redux state if needed, or provide defaults
const mapStateToProps = (state) => ({
  // If Dashboard needs these props from Redux, we need to ensure they exist
  // For demo purposes, we might need to provide mock data
  auth: state?.auth || {
    user: null,
    userProfile: null,
    loading: false
  },
  message: state?.message || {
    resError: null
  },
  dashboard: state?.dashboard || {
    raceData: null,
    sampleUser: null,
    loading: false
  }
});

// If your Redux store doesn't have these slices, you can export without connect:
// export default DemoDashboard;

// Or with connect to ensure Redux compatibility:
export default connect(mapStateToProps)(DemoDashboard);
